import { Task, TaskItem } from '../interfaces';
import { ItemStatus } from '../../store/interfaces';
import { SessionStore } from '../../constants/sessionStore';

const updateCurrentTaskItem = (taskItem: TaskItem, status?: ItemStatus): void => {
  const currentWorkflowItem = sessionStorage.getItem(SessionStore.currentWorkflowItem);
  if (currentWorkflowItem) {
    const workflowItem = JSON.parse(currentWorkflowItem);
    const config = JSON.parse(workflowItem.configuration);

    const tasks = config.configWidgetJSON.tasks.map((task: Task) => {
      if (task.id === taskItem.taskId) {
        return {
          ...task,
          items: task.items.map((item) => {
            if (item.id == taskItem.id) return { ...item, ...taskItem, status };  // eslint-disable-line
            return item;
          }),
        };
      }
      return task;
    });

    const updatedCurrentWorkflowItem = {
      ...workflowItem,
      configuration: JSON.stringify({
        ...config,
        configWidgetJSON: { ...config.configWidgetJSON, tasks },
      }),
    };

    sessionStorage.setItem(SessionStore.currentWorkflowItem, JSON.stringify(updatedCurrentWorkflowItem));
  }
};

export default updateCurrentTaskItem;
